
/* eslint-disable */
  export const prefix = ''
  export const IP = 'api.focuth.com'
  export const APIHOST = 'api.focuth.com'
//   export const HOST = '10.160.144.14:8001/'
  export const HOST = 'api-circle.fosun.com'
  export const CAMPHOST = 'campapi.focuth.com'
  export const BATTLEHOST = 'https://battle.focuth.com'
  // export const CALDNDAREHOST = 'http://ui-circle.fosun.com:8081'
  export const CALDNDAREHOST = 'https://calendar.ui-circle.fosun.com'
  export const safeHeight = 0
  export const ROOT = 'ui-circle.fosun.com'
  export const Cryptokey = 'salt2d9v_xy5dmf3'
  export const ddCorpId = 'ding7a05491d2e914134'
  